import type { MailboxInfo } from 'owa-client-ids';
import { lazyCreateNewFolder } from 'owa-folder-createnew';

export function createNewFolder(
    displayName: string,
    parentId: string,
    mailboxInfo: MailboxInfo
): Promise<string | null> {
    return lazyCreateNewFolder.importAndExecute({
        parentId,
        displayName,
        mailboxInfo,
    });
}

export function createNewGroupFolder(): any {
    // Dummy method to prevent users from creating folders inside Inbox
    // when invoking Copy/Move Message Action from groups.
    // Tracking Bug - Bug 131272: Add support to create Folders under Groups in Move To Component
    return Promise.resolve(null);
}
